<template>
  <v-expansion-panels v-model="panel" :disabled="disabled" multiple>
    <!-- PENDÊNCIAS DO FORNECEDOR -->
    <MinhasPendencias v-if="$route.name == 'modules'" />
    <v-expansion-panel v-for="moduleItem in me.modules" :key="moduleItem.id">
      <v-expansion-panel-header color="#007BC3">
        <template v-slot:actions>
          <v-icon color="white" class="font-weight-black">
            icon-up-arrow
          </v-icon>
        </template>
        <span class="white--text font-weight-bold" style="font-size: 20px">
          {{ moduleItem.title }}
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="px-15 pt-8 pb-15">
        <v-row>
          <template v-bind="feat.id" v-for="feat in moduleItem.features">
            <router-link
              :key="feat.id"
              v-if="feat.icon && hideModuleProvider(feat.route)"
              class="module col-12 col-xs-12 col-sm-4 col-lg-2"
              :to="{
                name: feat.route,
                params: { userId: me.id }
              }"
            >
              <span :class="[feat.icon, 'icon']"></span>
              <span class="module-name">{{ feat.title }}</span>
            </router-link>
          </template>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapGetters } from "vuex";
import MinhasPendencias from "./MinhasPendencias/";

export default {
  name: "Modules",
  components: {
    MinhasPendencias
  },

  computed: {
    ...mapGetters({
      me: "$_auth/me"
    })
  },

  data: () => ({
    panel: [0, 1, 2],
    disabled: false,
    readonly: false
  }),
  methods: {
    changeRoute(route) {
      this.$router.push({
        name: route,
        params: { id: this.me.providers[0].id }
      });
    },

    hideModuleProvider(module) {
      if (!this.me.employee_number && module == "user.index") return false;
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.text-instructions {
  background-color: #eeeeee;
  border-radius: 10px;
  padding: 10px 10px 1px 10px;
}
.title {
  letter-spacing: 0.1666666667em !important;
}
.btn-very-large {
  height: 82px;
  width: 82px;
}

.module {
  color: #444444;
  text-decoration: none;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  transition: color 300ms;

  &:hover {
    color: #007bc3;
  }

  .icon {
    font-size: 80px;
  }

  .module-name {
    font-weight: 600;
  }
}
</style>
